import { useState } from 'react';
import axios from 'axios';
import { motion } from "framer-motion";
import { Leaf, Truck, BadgeCheck, PiggyBank } from "lucide-react";

function SubscribeSection() {
  const promises = [
    { icon: <Leaf size={36} className="text-green-500" />, text: "Fresh & Organic Produce" },
    { icon: <Truck size={36} className="text-blue-500" />, text: "Fast & Reliable Delivery" },
    { icon: <BadgeCheck size={36} className="text-amber-500" />, text: "Quality You Can Trust" },
    { icon: <PiggyBank size={36} className="text-pink-500" />, text: "Affordable Prices Everyday" },
  ];
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

   const [form, setForm] = useState({
      email: ''
    });
  
    const handleChange = (e) => {
      const { name, value, files } = e.target;
      if (name === 'image') {
        setForm({ ...form, image: files[0] });
      } else {
        setForm({ ...form, [name]: value });
      }
    };
  
const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    await axios.post(
      `${API_BASE_URL}/email/add`,
      { email: form.email } // send as JSON
    );
    alert('Email added!');
  } catch (err) {
    console.error('Failed to add email:', err);
    alert('Failed to add email: ' + (err.response?.data?.message || err.message));
  }
};


  return (
    <div className="store-subscription relative bg-gradient-to-r from-green-100 via-white to-green-100 py-10 overflow-hidden">
      {/* Background Accent */}
      <div className="absolute inset-0 opacity-20  bg-cover bg-center" />

      <div className="relative max-w-6xl mx-auto px-6 flex flex-col items-center text-center">
        {/* Section Title */}
        <motion.h2
          initial={false}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-3xl md:text-4xl font-bold text-gray-800"
        >
          Freshness at Your Doorstep 🌱
        </motion.h2>
        <p className="mt-4 text-lg text-gray-600 max-w-xl">
          From farm to table, we make sure every bite is fresh, healthy, and delivered on time.
        </p>

        {/* Promises Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6 w-full">
          {promises.map((promise, i) => (
            <motion.div
              key={i}
              initial={false}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.2, duration: 0.4 }}
              whileHover={{ scale: 1.05 }}
              className="flex flex-col items-center bg-white p-4 rounded-2xl shadow-sm"
            >
              {promise.icon}
              <p className="mt-3 text-gray-700 font-medium">{promise.text}</p>
            </motion.div>
          ))}
        </div>

        {/* Newsletter */}
        <div className="mt-8 bg-white p-6 rounded-2xl shadow-sm w-full max-w-2xl">
          <h2 className="text-xl font-semibold text-gray-800">
            Subscribe & Get Weekly Deals 🍎
          </h2>
          <p className="text-gray-600 text-sm mt-1">
            Be the first to know about fresh arrivals, discounts & healthy recipes.
          </p>

          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row items-center mt-6 gap-4">
            <input
            name='email'
              type="email"
              aria-label="Email address for weekly deals"
              required
              value={form.email}
              onChange={handleChange}
              placeholder="Enter your email"
              className="w-full min-w-0 flex-1 border border-gray-300 rounded-lg px-4 py-3 outline-none focus:ring-2 focus:ring-green-400"
            />
            <button
              type="submit"
              className="w-full sm:w-auto px-6 py-3 bg-green-600 text-white rounded-lg font-medium hover:bg-green-700 transition"
            >
              Subscribe
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SubscribeSection;
